<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Global Scenario Bulk Update to Portfolio</h1>
  <div id="actions-container">
    <button mat-raised-button color="primary" id="bulk-vehicle-button" class="default-margin"
            (click)="bulkUpdateWithVehiclePortfolio()"
            [disabled]="memberScenarios.length === 0">
      Update with Vehicle Portfolio
    </button>
    <button mat-raised-button color="primary" id="bulk-propulsion-button" class="default-margin"
            (click)="bulkUpdateWithPropulsionPortfolio()"
            [disabled]="memberScenarios.length === 0">
      Update with Propulsion Portfolio
    </button>
  </div>
</div>
<div class="content-height w-100">
  <app-global-scenario-select-component
    [memberScenarioType]="0"
    [filterNonGM]="false"
    [user]="stateService.getUserGmid()"
    [displayedMemberColumns]="VEHICLE_PROPULSION_COLDEF_NO_FILTER"
    (confirmEvent)="onSelect($event)">
  </app-global-scenario-select-component>
</div>
